// src/pages/shop-settings-tabs/LanguageTab.jsx
import React from 'react';

// 全部语言的完整清单——和原来 ShopSettingsPage.jsx 里的 LANGUAGE_OPTIONS 一致
const LANGUAGE_OPTIONS = [
  { code: 'zh',    label: '中文' },
  { code: 'en',    label: 'English' },
  { code: 'km',    label: 'ខ្មែរ（高棉语）' },
  { code: 'ms',    label: 'Bahasa Melayu（马来语）' },
  { code: 'zh_tw', label: '繁體中文' },
];

const LanguageTab = ({ settings, toggleLanguage }) => (
  <div className="max-w-2xl space-y-6">
    <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 text-sm text-blue-700">
      <p>控制客户在H5商城、店员在POS后台能看到哪几个语言选项——不影响商品/分类名称的翻译内容本身。</p>
    </div>

    <div className="bg-white rounded-xl shadow p-5">
      <h3 className="font-semibold text-gray-800 mb-1">启用的语言</h3>
      <p className="text-sm text-gray-500 mb-3">同时控制H5商城和POS后台的语言切换选项</p>
      <div className="space-y-2">
        {LANGUAGE_OPTIONS.map(lang => (
          <label key={lang.code} className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox"
              checked={settings.enabled_languages.includes(lang.code)}
              onChange={() => toggleLanguage(lang.code)}
              className="w-4 h-4 rounded" />
            <span className="text-sm text-gray-700">{lang.label}</span>
          </label>
        ))}
      </div>
    </div>
  </div>
);

export default LanguageTab;